export default {
  props: ['id', 'token'],
  methods: {
    Login() {
      this.$store.dispatch('banners/InitialStoreBanners');
      this.$store.state.settings.external_load = true;
      if (this.$store.state.settings.extranet !== true) {
        this.$router.push('/');
      }

      const app = this;
      const data = { external_id: app.id, external_token: app.token };

      app.$store.getters.axl.post('api/login/external', data)
        .then((response) => {
          app.$store.dispatch('UserLogin', response.data);
          this.$store.state.settings.external_load = false;
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  mounted() {
    this.Login();
  },
};
